import { render, staticRenderFns } from "./indexZh.vue?vue&type=template&id=04fc45aa&scoped=true&"
import script from "./indexZh.vue?vue&type=script&lang=js&"
export * from "./indexZh.vue?vue&type=script&lang=js&"
import style0 from "./indexZh.vue?vue&type=style&index=0&id=04fc45aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fc45aa",
  null
  
)

export default component.exports